import { render, staticRenderFns } from "./My-Account.vue?vue&type=template&id=6888b19f&scoped=true&"
import script from "./My-Account.vue?vue&type=script&lang=js&"
export * from "./My-Account.vue?vue&type=script&lang=js&"
import style0 from "./My-Account.vue?vue&type=style&index=0&id=6888b19f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6888b19f",
  null
  
)

export default component.exports